import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import gallery from "../../../Utils/Images/Gallery Send.png"; 
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../../Components/Button/CustomButton";
import CustomInput from "../../../Components/input/CustomInput";
import { handleAddVoucher } from "../../../APIs/Function/Voucher/AddVoucher";

const AddVoucher = () => {
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    link: "",
    code: "",
    voucher_type: "",
    discount_type: "",
    discount_value: null,
    image: null,
  });
  const initialFormData = {
    name: "",
    description: "",
    link: "",
    code: "",
    voucher_type: "",
    discount_type: "",
    discount_value: null,
    image: null,
  };

  const discountValueOptions =
    formData.discount_type === "2"
      ? ["100", "200", "300"]
      : formData.discount_type === "1"
      ? ["10", "20", "30"]
      : [];
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const image = event.target.files[0];
    if (image) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setPreviewImage(e.target.result); // Set the data URL as the preview image
      };

      reader.readAsDataURL(image); // Read the file as data URL
    } else {
      setPreviewImage(gallery); // Set the placeholder image if no file is selected
    }
    setFormData({
      ...formData,
      image: image,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      formData.code.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.image &&
      formData.link.trim() !== "" &&
      formData.name.trim() !== ""
    ) {
      try {
        setLoading(true);
        let res = await handleAddVoucher(formData);
        if (res.s) {
          setLoading(false);
          alert("Data Added Succesfully");
          navigate("/voucher");
        }
        setFormData(initialFormData);
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please Fill All Fields");
    }
  };

  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/voucher"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Add Details
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      {/* form */}
      <Container maxWidth="sm" sx={{ mt: "30px",height:'90vh',overflow:'auto' }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={4}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Code"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12}>
              <CustomInput
                label="Link"
                name="link"
                value={formData.link}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: "15px" }}>
              <FormControl fullWidth required>
                <InputLabel
                  sx={{
                    backgroundColor: "#FFF",
                  }}
                >
                  Voucher Type
                </InputLabel>
                <Select
                  name="voucher_type"
                  value={formData.voucher_type}
                  onChange={handleInputChange}
                  sx={{ textAlign: "left" }}
                >
                  <MenuItem value="1">For Product</MenuItem>
                  <MenuItem value="2">For Plan</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ mt: "15px" }}>
              <FormControl fullWidth required>
                <InputLabel
                  sx={{
                    backgroundColor: "#FFF",
                  }}
                >
                  Discount Type
                </InputLabel>
                <Select
                  name="discount_type"
                  value={formData.discount_type}
                  onChange={handleInputChange}
                  sx={{ textAlign: "left" }}
                >
                  <MenuItem value="1">Percentage</MenuItem>
                  <MenuItem value="2">Price</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ mt: "15px" }}>
              <FormControl fullWidth required>
                <InputLabel
                  sx={{
                    backgroundColor: "#FFF",
                  }}
                >
                  Discount Value
                </InputLabel>
                <Select
                  name="discount_value"
                  value={formData.discount_value}
                  onChange={handleInputChange}
                  disabled={!formData.discount_type}
                  sx={{ textAlign: "left" }}
                >
                  {discountValueOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="file-input">
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100px", height: "100px", mb: "10px" }}>
                    <img
                      height={"100%"}
                      width={"100%"}
                      src={previewImage.length ? previewImage : gallery}
                      alt="preview"
                    />
                  </Box>
                  <Typography>Upload Design Image</Typography>
                  <Typography sx={{ fontFamily: "Chillax Variable" }}>
                    (JPG,PNG,PSD,EPS)
                  </Typography>
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-input"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
};

export default AddVoucher;
